import { CloseOutlined, CopyOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, Form, Input, message, Modal, Space, Switch } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "@server";
import { useViewportBreakpoint } from "../../hooks/useViewportBreakpoint";

const CompanyToken = ({ token, visible, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const isMobile = useViewportBreakpoint() === "mobile";

  useEffect(() => {
    if (!visible) return;
    form.setFieldsValue({
      code: token?.code ?? "",
      active: token?.active ?? true,
    });
  }, [visible, token, form]);

  const copyCode = () => {
    const code = form.getFieldValue("code");
    if (code == null || String(code).trim() === "") {
      message.warning("Нет кода для копирования");
      return;
    }
    navigator.clipboard.writeText(String(code)).then(
      () => message.success("Скопировано"),
      () => message.error("Не удалось скопировать")
    );
  };

  const handleSave = () => {
    form.validateFields().then(values => {
      setLoading(true);
      const method = token?.id ? "PUT" : "POST";
      const url = token?.id ? `token/${token.id}` : "token";
      serverFetch(url, { method, bodyData: values })
        .then(() => {
          message.success(token?.id ? "Токен обновлен" : "Токен добавлен");
          onClose(true);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage || "Ошибка при сохранении");
        });
    });
  };

  const title = token?.id ? "Редактирование токена" : "Добавление токена";

  const codeRules = token?.id ? [] : [{ required: true, message: "Введите код" }];

  const formFields = (
    <>
      <Form.Item label="Код">
        <Space.Compact style={{ width: "100%" }} className="company-token-code-compact">
          <Form.Item name="code" noStyle rules={codeRules}>
            <Input readOnly={!!token?.id} disabled={loading} style={{ flex: 1, minWidth: 0 }} />
          </Form.Item>
          <Button
            type="default"
            icon={<CopyOutlined />}
            onClick={copyCode}
            disabled={loading}
            aria-label="Копировать код"
            className="company-token-code-copy-btn"
          />
        </Space.Compact>
      </Form.Item>
      {isMobile ? (
        <Form.Item label="">
          <div className="company-base-switch-row">
            <span>Активен</span>
            <Form.Item name="active" valuePropName="checked" noStyle>
              <Switch disabled={loading} />
            </Form.Item>
          </div>
        </Form.Item>
      ) : (
        <Form.Item label="Активен" name="active" valuePropName="checked">
          <Switch disabled={loading} />
        </Form.Item>
      )}
    </>
  );

  if (!visible) return null;

  if (isMobile) {
    return (
      <div>
        <div
          className="misoft-modal-overlay company-base-overlay--mobile"
          onClick={e => e.target === e.currentTarget && onClose(false)}
        >
          <div className="misoft-modal-content company-base-sheet--mobile" onClick={e => e.stopPropagation()}>
            <div className="company-base-sheet-header">
              <span className="company-base-sheet-title">{title}</span>
              <Space size="small" className="company-base-sheet-actions">
                <Button
                  type="primary"
                  icon={<SaveOutlined />}
                  onClick={handleSave}
                  loading={loading}
                  aria-label="Сохранить"
                  className="company-base-header-icon-btn"
                />
                <Button
                  type="default"
                  icon={<CloseOutlined />}
                  onClick={() => onClose(false)}
                  aria-label="Закрыть"
                  className="company-base-header-icon-btn"
                />
              </Space>
            </div>
            <div className="company-base-sheet-body">
              <Form form={form} layout="vertical" colon={false} style={{ width: "100%", maxWidth: "100%" }}>
                {formFields}
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Modal
      title={title}
      open={visible}
      onOk={handleSave}
      onCancel={() => onClose(false)}
      okText="Сохранить"
      cancelText="Отмена"
      confirmLoading={loading}
    >
      <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} colon={false} style={{ marginTop: 16 }}>
        {formFields}
      </Form>
    </Modal>
  );
};

export default CompanyToken;
